angular.module('sample.widgets.numberOfProjectsChart', ['adf.provider',
  "ngResource",
  "ivpusic.cookie",
  "EICDataStream3.resources",
  ])
    .config(['dashboardProvider', function (dashboardProvider) {
      dashboardProvider
          .widget('numberOfProjectsChart', {
            id: 'numberOfProjectsChart',
            title:       'Projects In EICDataStream',
            description: 'Shows the Number of Projects or CAPEX Analysed by Industry Sector',
            controller: 'NumberOfProjectsChartController',
            //   controllerAs: 'list',
            templateUrl: '/app-ds3/dashboard/widgets/numberOfProjectsChart/numberOfProjectsChart.partial.html' //,
//            edit:         {
//              templateUrl: '/app/angular-dashboard-framework/widgets/linklist/edit.html',
//              reload:      false,
//              controller:  'linklistEditCtrl'
//            }
          });
    }])
    .controller('NumberOfProjectsChartController', ['$scope', '$http', '$q',
  function ($scope, $http, $q) {
    $scope.componentName = "NumberOfProjectsController";
    var chartDataRequestCanceler = null;

    var getNextRequestConfig = function (baseConfig) {
      if (chartDataRequestCanceler) {
        chartDataRequestCanceler.resolve();
      }

      chartDataRequestCanceler = $q.defer();
      return angular.extend({}, baseConfig || {}, {
        timeout: chartDataRequestCanceler.promise
      });
    };

    $scope.chartTypes = ["Number", "CAPEX"];
    $scope.type="Number";

    $scope.options = {
      title:    {
        enable: true,
        text:   'Number of Future and Active Projects',
        class:  'h3'
      },
      subtitle: {
        enable: true,
        text:   'Analysed By Industry Sector and Region',
        class:  'h4'
      },

      chart: {
        type:               "multiBarChart",
        height:             600,
        margin:             {
          top:    100,
          right:  20,
          bottom: 160,
          left:   90        },
        clipEdge:           false,
        staggerLabels:      false,
        transitionDuration: 500,
        stacked:            true,
        xAxis:              {
          axisLabel:    'Region',
          rotateLabels: -45
        },
        reduceXTicks:       false,
        yAxis:              {
          axisLabel: 'Number of Projects',
          tickFormat: function (yValue) {
            return d3.format(',d')(yValue)
          }
        }

      }
    };

    $scope.$watch("type", function(){
      if($scope.type == "CAPEX"){
        $scope.getCAPEXtData();
        $scope.options.title.text = 'CAPEX of Future and Active Projects';
        $scope.options.chart.yAxis.axisLabel = 'CAPEX of Projects ($Milion)';
        $scope.options.chart.yAxis.axisLabelDistance = 20;
      }
      else{
        $scope.getCountData();
        $scope.options.title.text = 'Number of Future and Active Projects';
        $scope.options.chart.yAxis.axisLabel = 'Number of Projects';

      }
    });

    $scope.getCAPEXtData = function () {
      var a = $http.get('/api/ProjectCAPEXPerRegionAndSector',
          getNextRequestConfig({
//            params: {
//              industrySectors: $scope.selectedIndustrySectors,
//              regions:         $scope.selectedRegions
//            }
          }))
          .then(function (data, status, headers, config) {
            $scope.data = data;
          })
          .catch(function (data, status, headers, config) {
            var i = 0;
          });
    };

    $scope.getCountData = function () {
      var a = $http.get('/api/ProjectCountPerRegionAndSector',
          getNextRequestConfig({
            params: {
              industrySectors: $scope.selectedIndustrySectors,
              regions:         $scope.selectedRegions
            }
          }))
          .then(function (data, status, headers, config) {

            $scope.data = data;

          })
          .catch(function (data, status, headers, config) {
            var i = 0;
          });
    };



    $scope.$on('$viewContentLoaded', function () {

    });
    $scope.$on('$destroy', function () {
      if (chartDataRequestCanceler) {
        chartDataRequestCanceler.resolve();
      }
    });
    $scope.$emit('$viewContentLoaded');


  }]);

